import React from 'react';
import PayableIntegrationServiceView from './PayableIntegrationServiceView';

const createPayableIntegrationServiceView = (soid, comboFields) => {
  return () => <PayableIntegrationServiceView serviceOfferingId={soid} comboFields={comboFields} />;
};

export default createPayableIntegrationServiceView;
